import styled from 'styled-components';
import { palette } from 'styled-tools';

import { units } from '@calm-web/design-system';

import ContentCard from '@/components/app/cards/ContentCard';
import { InfoContainer, Subtitle, Title } from '@/components/app/cards/ContentCard/styles';

export const NoResults = styled.div`
	width: 100%;
	color: ${palette('adaptiveText', 'white')};
	padding: ${units(2.5)};
`;

export const SearchResultsStyled = styled.ul`
	padding: 0;
	width: 100%;

	li {
		list-style-type: none;
	}
`;

export const InlineContentCard = styled(ContentCard)`
	display: grid;
	grid-template-columns: 40% 1fr;
	grid-gap: ${units(1.5)};
	padding: ${units(1.5)};
	width: 100%;
	background-color: ${palette('inlineCardBgColor')};
	border-radius: ${units(1.5)};

	${InfoContainer} {
		display: flex;
		justify-content: center;
		flex-direction: column;
		margin-bottom: 0;
		margin-top: 0;
	}
	${Title} {
		color: ${palette('adaptiveText')};
	}
	${Subtitle} {
		color: ${palette('adaptiveText')};
	}
`;

export const GridSearchResultsStyled = styled.div`
	width: 100%;
`;
